module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp123_3009.9a39cf43.png";